import React from 'react'
import AliceCarousel from 'react-alice-carousel'
import Image from "./image";
import Link from './link';
import {LogoIcon} from "./icons";
import { ga4 } from '../handlers/google-analytic';
import { getGG } from '../state/store';

const NewItem = ({ item, className = '' }) => (
  <Link
    className={className}
    to={`/activity-detail`}
    state={{ newsCode: item.newsCode }}
    button_id='newsButtonId'
    onClick={() => {
      const { user } = getGG().store.getState()
      ga4.gtag('event', 'news_activities', {
        name: item.title,
        category: 'news',
        trigger: `newsButtonId-${item.title}`,
        profile_id: user.profileId
      });
    }}
  >
    <div className={'news-item'}>
      <div className={'news-image'}>
        <Image PlaceholderComponent={
          <div
            className={'coupon-wisdom-logo-box with-placeholder'}
            style={{
              height: 230,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <LogoIcon svg={{ height: '6em', className: 'coupon-wisdom-logo' }}/>
          </div>}
          src={item.image}
        />
      </div>
      <div className={'news-description'}>
        <div className={'news-title'}>
          { item.title }
        </div>
        <div className={'news-date'}>
          { item.date }
        </div>
      </div>
    </div>
  </Link>)

const NewsHome = ({ data = [] }) => {
  switch (data.length) {
    case 1: {
      return <div style={{ paddingLeft: 30, paddingRight: 30 }}>
        <div className='news-home'>
          {data.map(item => <NewItem item={item} />)}
        </div>
      </div>
    }
    case 2: {
      return <AliceCarousel
        className={'news-home'}
        mouseTrackingEnabled
        stagePadding={{ paddingLeft: 30, paddingRight: 30}}
        dotsDisabled={true}
        keysControlDisabled={true}
        isPrevSlideDisabled={true}
        isNextSlideDisabled={true}
        buttonsDisabled={true}
      >
        {data.map(item => <NewItem className="two" item={item} />)}
      </AliceCarousel>
    }
    default: {
      return <AliceCarousel
        className={'news-home'}
        mouseTrackingEnabled
        stagePadding={{ paddingLeft: 30, paddingRight: 30}}
        dotsDisabled={true}
        keysControlDisabled={true}
        isPrevSlideDisabled={true}
        isNextSlideDisabled={true}
        buttonsDisabled={true}
      >
        {data.map(item => <NewItem item={item} />)}
      </AliceCarousel>
    }
  }
}

export default NewsHome
